<template>
  <div
    class="base-inline-formula"
    :style="formulaStyle"
  >
    <template
      v-for="fieldIndex in fieldIndexes"
      :key="fieldIndex"
    >
      <div class="base-inline-formula__field">
        <slot :name="`field-${fieldIndex}`" />
      </div>

      <span
        v-if="separators[fieldIndex]"
        class="base-inline-formula__separator"
      >
        {{ separators[fieldIndex] }}
      </span>
    </template>
  </div>
</template>

<script>
const FIELD_SIZE_COLUMNS = {
  xs: "minmax(72px, 92px)",
  sm: "minmax(96px, 124px)",
  md: "minmax(116px, 148px)",
  lg: "minmax(132px, 164px)",
  xl: "minmax(136px, 172px)",
};

export default {
  name: "BaseInlineFormula",

  props: {
    fields: {
      type: Number,
      required: true,
    },
    separators: {
      type: Array,
      default: () => [],
    },
    sizes: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    fieldIndexes() {
      return Array.from({ length: this.fields }, (_, index) => index);
    },

    formulaStyle() {
      return {
        gridTemplateColumns: this.gridTemplateColumns,
      };
    },

    gridTemplateColumns() {
      return this.fieldIndexes
        .flatMap((fieldIndex) => {
          const size = this.sizes[fieldIndex] || "md";
          const columns = [FIELD_SIZE_COLUMNS[size] || FIELD_SIZE_COLUMNS.md];

          if (this.separators[fieldIndex]) {
            columns.push("16px");
          }

          return columns;
        })
        .join(" ");
    },
  },
};
</script>

<style scoped>
.base-inline-formula {
  display: inline-grid;
  align-items: start;
  max-width: 100%;
  padding: 10px;
  column-gap: 6px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 6px;
  background: var(--color-background-secondary, #f9fafb);
}

.base-inline-formula__field {
  min-width: 0;
}

.base-inline-formula__field :deep(.form-group) {
  gap: 4px;
}

.base-inline-formula__field :deep(.label) {
  min-height: 18px;
  font-size: 12px;
  line-height: 18px;
}

.base-inline-formula__field :deep(.input) {
  height: 36px;
  min-height: 36px;
  padding-right: 28px;
  padding-left: 8px;
  font-size: 14px;
  text-align: right;
}

.base-inline-formula__field :deep(.big-number-wrapper .clear-button) {
  right: 4px;
  width: 18px;
  height: 18px;
}

.base-inline-formula__separator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 36px;
  margin-top: 22px;
  color: var(--color-text-secondary, #6b7280);
  font-size: 15px;
  font-weight: 600;
}

@media (max-width: 520px) {
  .base-inline-formula {
    display: grid;
    grid-template-columns: 1fr !important;
    width: 100%;
  }

  .base-inline-formula__separator {
    display: none;
  }
}
</style>
